import React from 'react';
import Slider from 'react-slick';
import { useNavigate } from 'react-router';

import { useTranslation } from '@common/hooks/translation';
import { ascSort } from '@common/helpers/declarative/sortings';
import { getBannerContentPositionName, getBannerImageUrl } from '@app/dev/helpers/banners';

const PageSlide = ({ link, redirectUrl, text, icon, iconPosition }) => {
  const t = useTranslation();
  const navigate = useNavigate();

  const isExternal = redirectUrl?.startsWith('http');

  const onNavigate = () => {
    if (!redirectUrl) return;
    if (isExternal) {
      window.open(redirectUrl, '_self');
    } else {
      navigate(redirectUrl);
    }
  };

  const hasText = Boolean(text);
  const positionClass = `home-icon-pos-${getBannerContentPositionName(iconPosition, hasText)}`;
  const bgStyle = link
    ? { backgroundImage: `url('${getBannerImageUrl(link)}')`, backgroundSize: 'cover', backgroundPosition: 'center' }
    : {};

  return (
    <div
      className={`home-page-item ${positionClass}`}
      onClick={redirectUrl ? onNavigate : undefined}
      style={{ cursor: redirectUrl ? 'pointer' : 'default', ...bgStyle }}
    >
      {icon && <img src={`data:image/png;base64,${icon}`} alt="" className="home-page-item-icon" />}
      {text && <span className="home-page-item-text">{t(text)}</span>}
    </div>
  );
};

export const PageItemRemote = ({ slides }) => {
  if (!slides?.length) return null;

  if (slides.length === 1) return <PageSlide {...slides[0]} />;

  const sorted = [...slides].sort(ascSort('index'));

  return (
    <div className="home-page-slides">
      <Slider
        dots={false}
        accessibility={false}
        arrows={false}
        autoplay
        infinite
        draggable
        autoplaySpeed={5000}
        dragging={false}
        slidesToShow={1}
        slidesToScroll={1}
      >
        {sorted.map((item, index) => (
          <PageSlide key={index} {...item} />
        ))}
      </Slider>
    </div>
  );
};
